export const RIGHTS_GROUP_MAP = [
	{ key : 'brandAnalysis' , cn : '品牌分析(ABA)' , weight : 0 },
	{ key : 'trafficSource' , cn : '查流量来源', weight : 1},
	{ key : 'reverseSearch' , cn : '反查流量词' , weight : 2},
	{ key : 'keywordMonitoring' , cn : '关键词监控', weight : 3},
	{ key : 'keywordAnalysis' , cn : '流量词分析', weight : 2},
];

export function getRightsByGroup(key){
	return RIGHTS_GROUP_MAP.find(i => i.key === key)
}

export function getRightsCnByGroup(key){
	return RIGHTS_GROUP_MAP.find(i => i.key === key).cn
}